import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const saleEvent = createSlice({
	name: "saleEvent",
	initialState: {
		loading: false,
        error: null,
		filter:{
			page : 1,
			limit : DATA_LIMIT,
			haveAssign: false,
		},
        items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
            state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const saleEventActions = saleEvent.actions;
//Reducers
export const saleEventReducer = saleEvent.reducer;
//Selectors
export const saleEventItemsSelector = (state) => state.saleEvent.items;
export const saleEventLoadingSelector = (state) => state.saleEvent.loading;
export const saleEventErrorSelector = (state) => state.saleEvent.error;
export const saleEventFilterSelector = (state) => state.saleEvent.filter;
export const saleEventPaginationSelector = (state) => state.saleEvent.pagination;